import {
    Checkbox,
    Typography,
    TextField,
    makeStyles,
    FormControlLabel,
  } from "@material-ui/core";
  import { Autocomplete } from "@material-ui/lab";
  import { classes as workerStyles } from "../AddWorkerStyles";
  import React, { useEffect, useState } from "react";
  import { getLocationForCountry } from "services/bulkUpload";
  import { Controller, useFormContext } from "react-hook-form";
  import { isEmptyObject } from "utils";
  import { useTranslation } from "react-i18next";
  import { properCase } from "utils";
  
  const useStyles = makeStyles((theme) => workerStyles(theme));
  
  const SmartSortUser = ({
    selectedWorker,
    manager,
    initialValue,
    setSmartSortValid,
    setIsSmartSortWorker,
    setSmartSortDistBuilingMap,
    smartSortDistBuilingMap,
  }) => {
    const classes = useStyles();
    const { control, setValue, getValues, errors, clearErrors } =
      useFormContext();
      const [userId, setUserId] = useState("");
      const [districts, setDistricts] = useState([]);
      const [buildings, setBuildings] = useState([]);
      const [isActiveTicked, setIsActiveTicked] = useState(false);
      const [smartSortDistrict, setSmartSortDistrict] = useState([]);
      const [smartSortBuilding, setSmartSortBuilding] = useState([]);
      const [smartSortRole, setSmartSortRole] = useState(null);
      const { t, i18n } = useTranslation();

  useEffect(() => {
   
    if (!isEmptyObject(initialValue) ) {
      setValue("isSmartSortActive", initialValue.isActive);
      console.log("ssd"+districts);
    if(initialValue.onlDistricts && initialValue.onlDistricts.length>0){
        console.log(initialValue);
        let districtData=[];
        districts.forEach((record)=>{
            if(initialValue.onlDistricts.includes(record.district)){
              districtData.push(record);
            }
        });
        setValue('smartSortDistrict', districtData);
      } 
      
      if(initialValue.onlBuildings && initialValue.onlBuildings.length>0){
        setValue("smartSortBuilding", initialValue.onlBuildings.map((item) => item.buildingID ? item.buildingID : item));
        }
      else{
        setValue("smartSortBuilding", []);
      }
      if (initialValue.userId != "") {
        setValue("userId", initialValue.userId);
      }
      setValue("smartSortRole", initialValue.role);

      setIsActiveTicked(initialValue?.isActive);
      setSmartSortDistrict(initialValue?.onlDistricts);
      setSmartSortBuilding(initialValue?.onlBuildings)
      setSmartSortRole(initialValue?.role);
      setUserId(initialValue?.userId)
    }
  }, [initialValue, districts]);

  useEffect(() => {
    console.log("selectedWorker"+selectedWorker);
    getLocationForCountry()
          .then((data) => {
            let districtBuildingObj={};
            console.log("buildingData1",data);
            data.forEach((record)=>{
              let DistSmartSortLTP = false;
              let buildingIdMap ={};
              Object.entries(record.buildings).map((buildingDet)=>{
                //console.log("buildingDet"+ buildingDet[1].wms);
                console.log("buildingData", buildingDet[1].wms);
                 if(buildingDet[1].wms ==="LTP" ){
                // if(1){
                  DistSmartSortLTP =true;
                  // buildingIdMap[buildingDet[0]]={
                  //   buildingID:buildingDet[0]
                  // };
                  buildingIdMap[buildingDet[0]]={
                    buildingID:buildingDet[0],
                    districtID:record.district,
                   
                  };
                }
              });
              if(buildingIdMap && Object.keys(buildingIdMap).length>0){
                districtBuildingObj[record.district] =buildingIdMap; 
              }
              record.DistSmartSortLTP = DistSmartSortLTP;
            });
           const  filteredDistricts = data.filter((record)=> record.DistSmartSortLTP === true);
             setSmartSortDistBuilingMap(districtBuildingObj);
             console.log("filteredDistricts"+filteredDistricts);
              setDistricts([...filteredDistricts]);
            
          })
          .catch((err) => {
            console.log("Get districts in SmartSort User access ", err);
          })
      
  }, []);
  
  useEffect(() => {
    if (getValues("isSmartSortActive") || initialValue?.isActive) {
        setIsSmartSortWorker(true);
    } else {
        setIsSmartSortWorker(false);
    }
  }, [isActiveTicked]);

  useEffect(() => {
    
    if (getValues("smartSortDistrict")?.length === 0 && buildings && buildings.length>0){
        setBuildings([]);
    }
    if (getValues("isSmartSortActive")) {
      if (getValues("smartSortDistrict")?.length === 0 ||
        getValues("smartSortBuilding")?.length===0 ||
        getValues("smartSortRole")?.length === 0 ||
        getValues("userId")?.length === 0 ||
        getValues("smartSortRole") === null) {
        setSmartSortValid(false);
      } else setSmartSortValid(true);
    } else {
        setSmartSortValid(true);
    }
  }, [
    getValues("smartSortDistrict"),
    getValues("smartSortBuilding"),
    getValues("isSmartSortActive"),
    getValues("smartSortRole"),
    getValues("userId")
  ]);
  return (
    <>

    <Typography
        variant="h6"
        gutterBottom
        className={`${classes.employeeId} ${classes.title}`}
      >
        {t("other.lblOneilUser")}
      </Typography>
      
      <FormControlLabel
        control={
          <Controller
          style={{ width: 300 }}
            name="isSmartSortActive"
            control={control}
            defaultValue={isActiveTicked}
            render={(props) => (
              <>
                <Checkbox
                  {...props}
                  checked={props.value}
                 
                  onChange={(e) => {
                    setIsActiveTicked(e.target.checked);
                    props.onChange(e.target.checked);
                  }}
                  color="primary"
                  style={{ paddingLeft: 0 }}
                  inputRef={props.ref}
                />
              </>
            )}
          />
        }
        label={t("other.lblEnableOneilUser")}
      />
      <Typography
       >
     </Typography>
     <Controller
          name="userId"
          id="userId"
          control={control}
          //value={userId}
          defaultValue={userId}
          render={(props) => (
            
              <TextField
                {...props}
                style={{ marginTop: 20, width: 260  }}
                id="userId"
                name="userId"
                label= {properCase(props.value? t("other.lblUserID") : t("other.lblEnterUserID"))}
                required={isActiveTicked}
                disabled={!isActiveTicked}
              />
            
          )}
        />
        <Controller
        name="smartSortDistrict"
        control={control}
        defaultValue={smartSortDistrict}
        disabled={!isActiveTicked}
        render={(props) => (
          <Autocomplete
            size="small"
            multiple
            style={{ marginTop: 20, marginBottom: 20 }}
            options={districts}
            value={props.value}
            disableClearable
           // disableCloseOnSelect
            clearOnBlur
             getOptionLabel={(option) => option.district?option.district:option}
            disabled={!isActiveTicked}
            renderInput={(params) => (
              <TextField
                {...params}
                // {...props}
                style={{ maxWidth: 300 }}
                id="smartSortDistrict"
                name="smartSortDistrict"
                label= { properCase( props.value != '' ? t("other.lblDistrict") : t("general.select1"))}
                required={isActiveTicked}
                error={
                  Boolean(errors.smartSortDistrict)
                }
                 
              />
            )}
            onChange={(e, newValue) => {
                props.onChange(newValue);
                if(!newValue|| newValue.length<=0){
                  setValue('smartSortBuilding', []);
                }
                let activatedBuildings =[];
                newValue.forEach((record)=>{
                  const buildingsData = record.buildings;
                  let buildingIds = Object.keys(buildingsData).filter(
                    (e) => buildingsData[e].wms === "LTP" 
                  );
                  activatedBuildings.push(...buildingIds)
                });
                
                  if(getValues('smartSortBuilding').length>0){
                    const filteredbuildingIds = getValues('smartSortBuilding').filter((buildingId)=>{
                      return activatedBuildings.includes(buildingId)
                    });
                    setValue('smartSortBuilding', filteredbuildingIds);
                  }
                
                setBuildings(activatedBuildings);
                 
            }}
          />
        )}
      />
    <Controller
        name="smartSortBuilding"
        control={control}
        defaultValue={smartSortBuilding}
        disabled={!isActiveTicked}
        render={(props) => (
          <Autocomplete
            size="small"
            multiple
            style={{ marginTop: 20, marginBottom: 20 }}
            options={buildings}
            value={props.value}
            disableClearable
            disableCloseOnSelect = {( buildings.length > 1 ? true : false)}
            disabled={!isActiveTicked}
            getOptionLabel={(option) => option?.buildingID?option.buildingID:option}
            renderInput={(params) => (
              <TextField
                {...params}
                // {...props}
                style={{ maxWidth: 300 }}
                id="smartSortBuilding"
                name="smartSortBuilding"
                label={properCase( props.value && props.value.length > 0 ? t( "other.lblBuilding") : t( "general.select2" ))}
                required={getValues("isSmartSortActive")}
                error={
                  Boolean(errors.smartSortBuilding)
                }
                
              />
            )}
            onChange={(e, val) => {
              props.onChange(val);
            }}
          />
        )}
      />


    <Controller
        name="smartSortRole"
        control={control}
        defaultValue={smartSortRole}
        disabled={!isActiveTicked}
        rules={isActiveTicked ? { required: "Role cannot be blank" } : false}
        render={(props) => (
          <Autocomplete
            size="small"
            style={{ marginTop: 20, marginBottom: 20 }}
            options={["Worker", "Project Manager", "Supervisor","Administrator"]}
            value={props.value}
            disableClearable
            required={isActiveTicked}
            disabled={!isActiveTicked}
            renderInput={(params) => (
              <TextField
                {...params}
                // {...props}
                style={{ maxWidth: 300 }}
                id="smartSortRole"
                name="smartSortRole"
                label={properCase( props.value ? t( "other.lblRole") : t( "other.lblSelectRole" ))}
                required={isActiveTicked}
                error={Boolean(errors.smartSortRole) && isActiveTicked}
                helperText={errors.smartSortRole?.message}
              />
            )}
            onChange={(e, val) => {
              props.onChange(val);
            }}
          />
        )}
      />

     </>
  );




  };
  
  export default SmartSortUser;
  